var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerApplicationDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33222 19.326V19.3215C1.33222 9.59353 9.25843 1.6665 18.9989 1.6665C28.7389 1.6665 36.6656 9.59312 36.6655 19.3332L36.6656 19.3377C36.6976 26.4595 32.2526 33.2178 27.619 38.294C25.321 40.8116 23.0177 42.8706 21.2879 44.3006C20.4238 45.0149 19.7048 45.5706 19.2038 45.9464C19.1297 46.0019 19.0604 46.0535 18.9961 46.1011C17.5657 45.0573 13.807 42.1794 10.1151 38.1061C5.57755 33.1 1.3001 26.4619 1.33222 19.326ZM8.66556 19.3332C8.66556 25.0421 13.2899 29.6665 18.9989 29.6665C24.7078 29.6665 29.3322 25.0421 29.3322 19.3332C29.3322 13.6242 24.7078 8.99984 18.9989 8.99984C13.2899 8.99984 8.66556 13.6242 8.66556 19.3332Z",
    fill: "#C8DBEA",
    stroke: "#7DADD1",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerApplicationDone);
export default __webpack_public_path__ + "static/media/markerApplicationDone.310b963b.svg";
export { ForwardRef as ReactComponent };